export const energySources = [
  { id: 'fuel', value: '油車' },
  { id: 'electric', value: '電動車' },
];

export const vehicleTypes = [
  { id: 'car', value: '汽車' },
  { id: 'moto', value: '機車' },
  { id: 'trailer', value: '拖車' },
];

export const electricVehicleTypes = [
  { id: 'car', value: '汽車' },
  { id: 'moto', value: '機車' },
];

export const oilTypes = [
  { id: 'gas_92', value: '92汽油' },
  { id: 'gas_95', value: '95汽油' },
  { id: 'gas_98', value: '98汽油' },
  { id: 'diesel', value: '柴油' },
];
